/**
 * WordPress dependencies
 */
import { loop as icon } from '@wordpress/icons';
/**
 * Internal dependencies
 */

const metadata = {
  $schema: "https://schemas.wp.org/trunk/block.json",
  apiVersion: 2,
  name: "core/query-no-results",
  title: "No results",
  category: "theme",
  description: "Contains the block elements used to render content when no query results are found.",
  parent: ["core/query"],
  textdomain: "default",
  usesContext: ["queryId", "query"],
  supports: {
    align: true,
    reusable: false,
    html: false,
    color: {
      gradients: true,
      link: true
    }
  }
};
import edit from './edit';
import save from './save';
const {
  name
} = metadata;
export { metadata, name };
export const settings = {
  icon,
  edit,
  save
};
//# sourceMappingURL=index.js.map